import { Site } from "./Site"

export type CatalogKey = keyof Pick<Site, "RefMotoActif" | "RefVdlActif" | "AutovistaActif" | "KifalActif" | "AutobizActif">

export const CATALOG_KEYS: CatalogKey[] = [
    "AutovistaActif",
    "RefMotoActif",
    "RefVdlActif",
    "KifalActif",
    "AutobizActif",
]

export const CATALOG_LABELS: Record<CatalogKey, string> = {
    AutovistaActif: "Autovista",
    RefMotoActif: "Référentiel Moto",
    RefVdlActif: "Référentiel VDL",
    KifalActif: "Kifal",
    AutobizActif: "Autobiz",
}
